<template>
  <div class="bbp-input-textarea">
    <div
      :class="[
        'bbp-input',
        'bbp-input_textarea',
        error && 'bbp-input_error'
      ]"
      contenteditable
      :ref="`textarea-editor_${input.id}`"
      @input="onInput"
      @keyup="keyup"
      :style="inputStyle"
    >{{content}}</div>
    <transition name="fade">
      <span class="bbp-input-textarea__error bbp-error-text" v-if="error">{{error}}</span>
    </transition>
    <BBPSelectImage
      v-if="isShowSelect"
      :options="input.options"
      :isOpen.sync="isShowSelect"
      :isHideSearch="true"
      :isNoMouseClose="true"
      :search="search"
      :position="popupPosition"
      label="username"
      @change="setSelect"
    />
  </div>
</template>

<script>
import {get, uniqueId} from 'lodash'
import BBPSelectImage from '@/components/Main/InputFields/BBPSelectImage/BBPSelectImage'

export default {
  name: 'BBPTextareaEditor',
  components: {
    BBPSelectImage
  },
  props: ['input', 'model', 'errorText', 'project'],
  data () {
    return {
      value: '',
      content: '',
      error: '',
      isShowSelect: false,
      search: '',
      commentUsers: [],
      popupPosition: {},
      currentIndexLetter: undefined,
      username: '',
      id: null,
      currentElem: null
    }
  },
  computed: {
    isAddUser () {
      const { isAddUser = false } = this.input
      return isAddUser
    },
    inputStyle () {
      const { inputStyle } = this.input
      return inputStyle
    },
    options () {
      const { options = [] } = this.input
      return options
    }
  },
  methods: {
    setDefaultVal () {
      const value = get(this.model, this.input.model, '')
      if (value) {
        this.value = value
        this.content = value
      }
    },
    addUserName (username) {
      const element = document.getElementById(this.id)
      const txt = document.createTextNode(username)
      // const txt = document.createTextNode(`${username} `)
      element.appendChild(txt)
    },
    capitalize (str) {
      return str.replace(/(^|\s)\S/g, (a) => a.toUpperCase())
    },
    updateValue () {
      const name = `@${this.search}`
      const reg = new RegExp(`(^|[^>])(${name})`, 'g')
      this.value = this.value.replace(reg, '')
    },
    setSelect ({ _id, username }) {
      this.updateValue()
      const name = this.capitalize(username)
      this.addUserName(name)
      this.commentUsers.push({_id, name})
      this.project.commentUsers = this.commentUsers
      this.closeModal()
    },
    createCurrentIndexLetter () {
      for (let i = 0; i < this.value.length; i++) {
        const current = this.value[i]
        const next = this.value[i + 1]
        let prev = this.value[i - 1]
        if (prev) prev.trim()
        if (current === '@' && (next === ' ' || !next) && (prev === ' ' || !prev)) {
          this.currentIndexLetter = i
        }
      }
    },
    keyup ({ key }) {
      if (!this.isAddUser) return
      if (key !== '@') return
      this.isShowSelect = key === '@'
      this.createWrapperName()
    },
    onInput (e) {
      this.value = e.target.innerText
    },
    createWrapperName () {
      const { id } = this.input
      const editor = this.$refs[`textarea-editor_${id}`]
      const html = editor.innerHTML
      this.id = uniqueId()
      const span = `<span
                      class='bbp-input-textarea__editor'
                      contenteditable="false"
                      id= ${this.id}
                    >@</span>`
      editor.innerHTML = html.replace(/(^|[^>])(@)/g, ` ${span}`)
      this.createPositionPopup()
      this.createPositionCursor(editor)
    },
    createPositionPopup () {
      const element = document.getElementById(this.id)
      if (!element) {
        this.closeModal()
        return
      }
      const { top, left } = element.getBoundingClientRect()

      this.popupPosition = {
        top: `${top + 20}px`,
        left: `${left + 20}px`
      }
    },
    createPositionCursor (editor) {
      const range = document.createRange()
      range.selectNodeContents(editor)
      range.collapse(false)
      const sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(range)
      editor.focus()
    },
    closeModal () {
      this.isShowSelect = false
      this.search = ''
      this.currentIndexLetter = undefined
    },
    onSearch () {
      if (this.currentIndexLetter === undefined) return
      const value = this.value.slice(this.currentIndexLetter + 1).toLowerCase()
      const search = value.split(' ')[0]
      this.search = search
    }
  },
  watch: {
    async value (newVal, oldVal) {
      this.error = false
      this.$emit('error', false)
      this.$emit('input', this.value)
      if (this.currentIndexLetter !== undefined && oldVal && oldVal[this.currentIndexLetter]) {
        this.closeModal()
      }
      if (!this.isAddUser) return
      await this.createCurrentIndexLetter()
      this.onSearch()
    },
    errorText () {
      this.error = this.errorText
    }
  },
  beforeMount () {
    this.setDefaultVal()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbp-input-textarea {
    position: relative;

    &__error {
      position: absolute;
      bottom: 10px;
      right: 12px;
      font-size: 13px;
      line-height: 16px;
      font-weight: 400;
      color: $color-pomegranate;
      pointer-events: none;
    }

    .bbp-input {
      height: 116px;
      overflow: auto;
      -ms-overflow-style: none;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        width: 0;
        height: 0;
      }
    }
  }

</style>

  <style lang="scss" >
    @import "../../../../sass/variables";

    .bbp-input-textarea {

      &__editor {
        color: $color-denim;
      }

      .bb-loader-select-header {
        position: absolute !important;
        top: 0;
        left: 0;
        right: 0;
        width: 1px;
        height: 1px !important;
      }

      .bb-loader-select-dropdown-menu {
        max-width: 281px;
        max-height: 300px !important;
      }
    }
  </style>



// WEBPACK FOOTER //
// src/components/Main/BBPForm/BBPTextareaEditor/BBPTextareaEditor.vue